import { Button } from '@/components/ui/button';
import { CalendarCheckIcon, UserPlusIcon } from '@phosphor-icons/react';

interface HomeQuickActionsProps {
  canRegisterGuest: boolean;
  onViewEvents: () => void;
  onRegisterGuest?: () => void;
}

export function HomeQuickActions({
  canRegisterGuest,
  onViewEvents,
  onRegisterGuest,
}: HomeQuickActionsProps) {
  return (
    <div className="mb-6">
      <div className="grid grid-cols-2 gap-2">
        <Button
          variant="outline"
          className="h-14 flex items-center justify-center gap-2"
          onClick={onViewEvents}
        >
          <CalendarCheckIcon size={24} weight="bold" />
          <span className="">My RSVPs</span>
        </Button>
        {canRegisterGuest && onRegisterGuest && (
          <Button
            variant="outline"
            className="h-14 flex  items-center justify-center gap-2"
            onClick={onRegisterGuest}
          >
            <UserPlusIcon size={24} weight="bold" />
            <span className="">Register Guest</span>
          </Button>
        )}
      </div>
    </div>
  );
}

